<template>
  <div
    id="thematic-modal-wrapper"
    class="d-flex p-6 text-center"
  >
    Coming soon!
  </div>
</template>

<script lang="ts">

import Vue from 'vue';

export default Vue.extend({

});
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

</style>
